'use client'

import { useEffect, useRef } from 'react'

import { useCurrentUser } from '@/hooks/useCurrentUser'

export const PendoProvider = ({ children }: { children: React.ReactNode }) => {
  const { business, user } = useCurrentUser()
  const initializedRef = useRef(false)

  useEffect(() => {
    if (typeof window === 'undefined' || !pendo?.initialize) return
    if (!user?.id || initializedRef.current) return

    initializedRef.current = true

    pendo.initialize({
      account: {
        availableDocumentationSources: business?.availableDocumentationSources,
        bitbucketConnected: business?.bitbucketConnected,
        codeConnected: business?.codeConnected,
        codeIndexing: business?.codeIndexing,
        confluenceConnected: business?.confluenceConnected,
        confluenceIndexing: business?.confluenceIndexing,
        disableManualReleaseNotesGeneration: business?.disableManualReleaseNotesGeneration,
        documentationCodeConnected: business?.documentationCodeConnected,
        documentationCodeIndexing: business?.documentationCodeIndexing,
        featurebaseConnected: business?.featurebaseConnected,
        githubConnected: business?.githubConnected,
        hasSeenDemoScreen: business?.hasSeenDemoScreen,
        id: business?.id,
        intercomConnected: business?.intercomConnected,
        intercomIndexing: business?.intercomIndexing,
        jiraConnected: business?.jiraConnected,
        launchdarklyConnected: business?.launchdarklyConnected,
        linearConnected: business?.linearConnected,
        name: business?.name,
        notionConnected: business?.notionConnected,
        notionIndexing: business?.notionIndexing,
        plan: business?.plan,
        slackConnected: business?.slackConnected,
        zendeskConnected: business?.zendeskConnected,
        zendeskIndexing: business?.zendeskIndexing,
      },
      visitor: {
        email: user.email,
        firstName: user.firstName,
        full_name: [user.firstName, user.lastName].filter(Boolean).join(' '),
        id: user.id,
        lastName: user.lastName,
        role: user.role,
        uniqueId: user.email,
        unreadUsersActivitiesCount: user.unreadUsersActivitiesCount,
        verified: user.verified,
      },
    })
  }, [user, business])

  return <>{children}</>
}
